import { Checkbox } from '@ghp/ui'
import { useId, type ReactNode } from 'react'
import s from './CheckRow.module.css'

export interface CheckRowProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  /** Cochée, la rangée passe au rouge « non conforme » : la destination constatée. */
  severe?: boolean
  children: ReactNode
}

/** L'`.acb` du prototype, cible entière : un carré de 24 px ne se vise pas au doigt. */
export function CheckRow({ checked, onCheckedChange, disabled, severe, children }: CheckRowProps) {
  const id = useId()

  return (
    <label
      className={s.root}
      htmlFor={id}
      data-on={checked ? '' : undefined}
      data-severe={severe === true ? '' : undefined}
    >
      <Checkbox id={id} checked={checked} disabled={disabled} onCheckedChange={onCheckedChange} />
      {children}
    </label>
  )
}
